import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice } from '@reduxjs/toolkit';
import { setCookie } from '@beef/utils';
import { DEFAULT_CHARS_LIMIT, ErrorReason, ErrorScreenType } from "../../../../shared/config";
var initialState = {
  isChatOpen: false,
  isDateBlockVisible: false,
  isMenuOpen: false,
  windowBlocked: false,
  isHistoryCalled: false,
  widgetConfig: {
    authZoneConfig: {},
    charsLimit: DEFAULT_CHARS_LIMIT
  },
  errorScreen: {
    retryCount: 0,
    reason: ErrorReason.UNKNOWN,
    type: ErrorScreenType.UNKNOWN
  }
};
export var settingsSlice = createSlice({
  name: 'settings',
  initialState: initialState,
  reducers: {
    setWidgetConfig: function setWidgetConfig(state, _ref) {
      var _payload$authZoneConf;
      var payload = _ref.payload;
      if ((_payload$authZoneConf = payload.authZoneConfig) !== null && _payload$authZoneConf !== void 0 && _payload$authZoneConf.zoneType) {
        var _payload$authZoneConf2;
        setCookie({
          name: 'chat_auth_zone',
          value: (_payload$authZoneConf2 = payload.authZoneConfig) === null || _payload$authZoneConf2 === void 0 ? void 0 : _payload$authZoneConf2.zoneType
        });
      }
      state.widgetConfig = _objectSpread(_objectSpread({}, state.widgetConfig), payload);
    },
    setIsDateBlockVisible: function setIsDateBlockVisible(state, _ref2) {
      var payload = _ref2.payload;
      state.isDateBlockVisible = payload;
    },
    setChatOpen: function setChatOpen(state, _ref3) {
      var payload = _ref3.payload;
      state.isChatOpen = payload;
    },
    setMenuOpen: function setMenuOpen(state, _ref4) {
      var payload = _ref4.payload;
      state.isMenuOpen = payload;
    },
    setWindowBlocked: function setWindowBlocked(state, _ref5) {
      var payload = _ref5.payload;
      state.windowBlocked = payload;
    },
    setIsHistoryCalled: function setIsHistoryCalled(state, _ref6) {
      var payload = _ref6.payload;
      state.isHistoryCalled = payload;
    },
    setErrorScreenType: function setErrorScreenType(state, _ref7) {
      var payload = _ref7.payload;
      if (state.errorScreen.type !== ErrorScreenType.BLOCK) {
        state.errorScreen.type = payload;
      }
      if (payload === ErrorScreenType.UNKNOWN || typeof payload === 'undefined') {
        state.errorScreen.reason = ErrorReason.UNKNOWN;
      }
    },
    setErrorReason: function setErrorReason(state, _ref8) {
      var payload = _ref8.payload;
      if (state.errorScreen.type !== ErrorScreenType.BLOCK) {
        state.errorScreen.reason = payload;
      }
    },
    clearErrorScreenData: function clearErrorScreenData(state) {
      state.errorScreen.reason = ErrorReason.UNKNOWN;
      state.errorScreen.type = ErrorScreenType.UNKNOWN;
    },
    setErrorRetryCount: function setErrorRetryCount(state, _ref9) {
      var payload = _ref9.payload;
      state.errorScreen.retryCount = payload;
    }
  }
});
var _settingsSlice$action = settingsSlice.actions,
  setChatOpen = _settingsSlice$action.setChatOpen,
  setWindowBlocked = _settingsSlice$action.setWindowBlocked,
  setIsDateBlockVisible = _settingsSlice$action.setIsDateBlockVisible,
  setMenuOpen = _settingsSlice$action.setMenuOpen,
  setWidgetConfig = _settingsSlice$action.setWidgetConfig,
  setErrorScreenType = _settingsSlice$action.setErrorScreenType,
  setErrorReason = _settingsSlice$action.setErrorReason,
  setIsHistoryCalled = _settingsSlice$action.setIsHistoryCalled,
  setErrorRetryCount = _settingsSlice$action.setErrorRetryCount,
  clearErrorScreenData = _settingsSlice$action.clearErrorScreenData;
export { setChatOpen, setWindowBlocked, setIsDateBlockVisible, setMenuOpen, setWidgetConfig, setErrorScreenType, setErrorReason, setIsHistoryCalled, setErrorRetryCount, clearErrorScreenData };